import React from "react";

export type TemplateDownloadIconVariant = "black" | "grey" | "white";

const VARIANT_COLORS: Record<TemplateDownloadIconVariant, string> = {
  black: "#161616",
  grey: "#6C737F",
  white: "#FFFFFF",
};

type TemplateDownloadIconProps = {
  variant?: TemplateDownloadIconVariant;
  /** Override variant with a custom color (e.g. "currentColor" to inherit from parent) */
  color?: string;
  size?: number;
  className?: string;
  "aria-label"?: string;
};

export const TemplateDownloadIcon: React.FC<TemplateDownloadIconProps> = ({
  variant = "black",
  color,
  size = 24,
  className = "",
  "aria-label": ariaLabel,
}) => {
  const fillColor = color ?? VARIANT_COLORS[variant];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={ariaLabel}
      aria-hidden={!ariaLabel}
    >
      <path
        d="M12.7502 4C12.7502 3.58579 12.4145 3.25 12.0002 3.25C11.586 3.25 11.2502 3.58579 11.2502 4V12.4619L11.2442 12.4548C11.0335 12.2061 10.8272 11.9434 10.6343 11.6976L10.5896 11.6407C10.3973 11.396 10.1951 11.1388 10.0381 10.9773C9.74935 10.6802 9.27453 10.6735 8.9775 10.9622C8.68048 11.2509 8.67373 11.7257 8.96243 12.0227C9.05114 12.114 9.19676 12.2958 9.40995 12.5672L9.45699 12.6271C9.64705 12.8693 9.87005 13.1534 10.0998 13.4245C10.346 13.715 10.6216 14.0168 10.897 14.2515C11.0351 14.369 11.1907 14.485 11.3581 14.5746C11.5195 14.661 11.742 14.75 12.0002 14.75C12.2585 14.75 12.481 14.661 12.6424 14.5746C12.8098 14.485 12.9654 14.369 13.1035 14.2515C13.3789 14.0168 13.6545 13.715 13.9007 13.4245C14.1304 13.1534 14.3534 12.8694 14.5434 12.6272L14.5905 12.5672C14.8037 12.2958 14.9494 12.114 15.0381 12.0227C15.3268 11.7257 15.32 11.2509 15.023 10.9622C14.726 10.6735 14.2511 10.6802 13.9624 10.9773C13.8054 11.1388 13.6031 11.396 13.4109 11.6407L13.3662 11.6977C13.1733 11.9434 12.967 12.2062 12.7563 12.4548L12.7502 12.4619V4Z"
        fill={fillColor}
      />
      <path
        d="M21.7074 14.2496C21.8453 13.859 21.6404 13.4306 21.2498 13.2928C20.8592 13.1549 20.4308 13.3598 20.293 13.7504L20.0591 14.413C19.5984 15.7184 19.2725 16.6385 18.9379 17.3282C18.6116 18.0007 18.3082 18.3853 17.9296 18.6531C17.551 18.921 17.0874 19.0791 16.3446 19.1629C15.5829 19.2489 14.6068 19.25 13.2224 19.25H10.778C9.39359 19.25 8.41753 19.2489 7.65581 19.1629C6.91303 19.0791 6.44937 18.921 6.0708 18.6531C5.69224 18.3853 5.38882 18.0007 5.06254 17.3282C4.72794 16.6385 4.40204 15.7184 3.94129 14.413L3.70745 13.7504C3.56959 13.3598 3.14119 13.1549 2.75059 13.2928C2.35999 13.4306 2.1551 13.859 2.29296 14.2496L2.54175 14.9545C2.98414 16.208 3.33715 17.2082 3.71299 17.9829C4.10137 18.7834 4.54467 19.4108 5.20444 19.8776C5.86422 20.3444 6.60339 20.5536 7.48754 20.6535C8.34313 20.75 9.40382 20.75 10.7331 20.75H13.2673C14.5966 20.75 15.6573 20.75 16.5129 20.6535C17.397 20.5536 18.1362 20.3444 18.796 19.8776C19.4557 19.4108 19.899 18.7834 20.2874 17.9829C20.6633 17.2082 21.0163 16.208 21.4587 14.9545L21.7074 14.2496Z"
        fill={fillColor}
      />
    </svg>
  );
};
